import { useRef, useEffect, useCallback } from "react";

const isBenignPlayError = (err) => {
  const name = err?.name || "";
  const message = String(err?.message || "");
  return (
    name === "AbortError" ||
    name === "NotAllowedError" ||
    /interrupted|pause\(\)/i.test(message)
  );
};

export const useVoicePreviewAudio = () => {
  const audioRef = useRef(null);
  const blobUrlRef = useRef("");

  const release = useCallback(() => {
    const audio = audioRef.current;
    if (audio) {
      try {
        audio.pause();
        audio.removeAttribute("src");
        audio.load();
      } catch (_) {}
      audioRef.current = null;
    }
    if (blobUrlRef.current) {
      try {
        URL.revokeObjectURL(blobUrlRef.current);
      } catch (_) {}
      blobUrlRef.current = "";
    }
  }, []);

  useEffect(() => () => release(), [release]);

  const stop = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;
    try {
      audio.pause();
      audio.currentTime = 0;
    } catch (_) {}
  }, []);

  const playBlob = useCallback(async (blob) => {
    release();

    const blobUrl = URL.createObjectURL(blob);
    blobUrlRef.current = blobUrl;

    const audio = new Audio(blobUrl);
    audioRef.current = audio;

    try {
      await audio.play();
    } catch (err) {
      if (isBenignPlayError(err)) return;
      throw err;
    }
  }, [release]);

  return { playBlob, stop, release };
};
